/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Steps_PlaceholderInputs */

const en_editor_steps_placeholder = /** @type {(inputs: Editor_Steps_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sweat the onions until soft.
Add the tomatoes and simmer for 20 min.`)
};

const de_editor_steps_placeholder = /** @type {(inputs: Editor_Steps_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwiebeln glasig dünsten.
Tomaten dazugeben und 20 Min. köcheln.`)
};

/**
* | output |
* | --- |
* | "Sweat the onions until soft. Add the tomatoes and simmer for 20 min." |
*
* @param {Editor_Steps_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_steps_placeholder = /** @type {((inputs?: Editor_Steps_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Steps_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_steps_placeholder(inputs)
	return en_editor_steps_placeholder(inputs)
});